export default "__VITE_ASSET__MlyaoL$4__"